import React from "react";

const STATUS_STYLES = {
  InProgress:        { bg: "#EBF4FF", color: "#1D6FA4", dot: "#3B9EDF" },
  AwaitingClient:    { bg: "#F1F5F9", color: "#334155", dot: "#64748B" },
  DocumentsRequired: { bg: "#FFFBEB", color: "#92400E", dot: "#F59E0B" },
  Approved:          { bg: "#F0FDF4", color: "#15803D", dot: "#4ADE80" },
  Rejected:          { bg: "#FEF2F2", color: "#991B1B", dot: "#EF4444" },
  CreditIssued:      { bg: "#ECFDF5", color: "#065F46", dot: "#10B981" },
};

const LeadTransferStatusBadge = ({ status, label }) => {
  const s = STATUS_STYLES[status] || { bg: "#F3F4F6", color: "#6B7280", dot: "#9CA3AF" };
  return (
    <span style={{
      display: "inline-flex",
      alignItems: "center",
      gap: 5,
      padding: "3px 10px 3px 7px",
      borderRadius: 20,
      background: s.bg,
      color: s.color,
      fontSize: 12,
      fontWeight: 600,
      lineHeight: "18px",
      whiteSpace: "nowrap",
    }}>
      <span style={{
        width: 7,
        height: 7,
        borderRadius: "50%",
        background: s.dot,
        flexShrink: 0,
      }} />
      {label}
    </span>
  );
};

export default LeadTransferStatusBadge;
